<template>
  <body>
<div class="menu-container">
  <div class="menu-items">
    <div class="menu-section">
      <h2>Drycker</h2>
      <ul>
        <li><span>Stor Stark 0,4L</span> <span>39:-</span></li>
        <li><span>Vin</span> <span>59:-</span></li>
        <li><span>Cider</span> <span>59:-</span></li>
        <li><span>Cava</span> <span>79:-</span></li>
        <li><span>Alkoholfritt</span> <span>35:-</span></li>
      </ul>
    </div>
    <div class="menu-section cent-content">
      <h2>Mat</h2>
      <ul>
        <li>Husets Plankstek</li>
        <li>Hamburgare</li>
        <li>Köttbullar</li>
        <li>Ceasarsallad</li>
        <li>Pasta Carbonara</li>
        <li><span>159:-</span></li>
      </ul>
    </div>
  </div>
</div>
</body>

</template>


<style scoped>
.cent-content ul {
  text-align: center; /* Centrerar texten i listan */
}

.cent-content li {
  justify-content: center; /* Centrerar varje listobjekt */
  display: flex; /* Behåller flexibilitet om fler element ska centreras */
}

body {
  background-color: #000;
  color: #fff;
  margin: 0;
  padding: 0;
}

.menu-container {
  text-align: center;
  padding: 50px 20px;
}

.menu-title {
  font-size: 4rem;
  color:#937d51;
  margin-bottom: 40px;
}

.menu-items {
  display: flex;
  justify-content: center;
  gap: 80px;
  flex-wrap: wrap;
}

.menu-section {
  background-color: #1e1e1e;
  border-radius: 15px;
  padding: 30px;
  width: 350px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
}

.menu-section h2 {
  font-size: 2rem;
  color: #937d51;
  border-bottom: 3px solid #937d51;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.menu-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-section li {
  font-size: 1.5rem;
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
  color: #fff;
}

.menu-section li span:first-child {
  text-align: left;
}

.menu-section li span:last-child {
  text-align: right;
  font-weight: bold;
}

</style>
